import {
  InputTypes,
  PaymentTypes,
  ValidatorTypes,
} from '@cashier/cashier-model';

import { provideAmountField } from '../staticDataProviders';
import { SchemaCollector } from './model';

const AMOUNT_NAME = 'amount';
const FIAT_AMOUNT_NAME = 'fiatAmount';

const AMOUNT_FIELD_NAMES = new Set([AMOUNT_NAME, FIAT_AMOUNT_NAME]);

const ACCOUNT_FIELD_NAME = 'accountId';
export const StaticDataCollector: SchemaCollector = {
  collect: (formSchema, field, context) => {
    const staticData = formSchema.staticData;

    if (!staticData.amount && AMOUNT_FIELD_NAMES.has(field.name)) {
      const enrichedAmount = provideAmountField(field, context);
      formSchema.staticData.amount = enrichedAmount;

      const { amounts } = context.paymentMethod;
      const amountSelector =
        field.name === AMOUNT_NAME &&
        field.type !== InputTypes.Select &&
        context.paymentType === PaymentTypes.Deposit &&
        amounts.length > 0 &&
        !context.isAmountStatic
          ? {
              ...enrichedAmount,
              params: {
                ...enrichedAmount.params,
                options: amounts.map((amount) => ({
                  label: amount,
                  value: amount,
                })) as any,
              },
            }
          : null;

      amountSelector && (formSchema.staticData.amountSelector = amountSelector);

      return;
    }

    if (!staticData.account && ACCOUNT_FIELD_NAME === field.name) {
      formSchema.staticData.account = {
        ...field,
        validatorType: ValidatorTypes.COMMON,
      };
    }
  },
  shouldCollect: (field) => {
    return (
      AMOUNT_FIELD_NAMES.has(field.name) || ACCOUNT_FIELD_NAME === field.name
    );
  },
};
